const prepareHTMLDocxConversion = (html) => {
  const headerStyles = 'line-height: 2.0; color: #EB6661; font-family: Raleway; font-weight: 100;';
  const headerStyles1 = `${headerStyles} font-size: 20px; text-align: center;`;
  const headerStyles2 = `${headerStyles} font-size: 24px; text-align: center;`;
  const headerStyles3 = `${headerStyles} font-size: 20px; text-align: left;`;
  const normalTextStyles = 'line-height: 24px; font-size: 15px; color: #0C1B1E; font-family: Baskervville;';
  const blockquoteStyles = `${normalTextStyles} font-weight: 600; text-align: justify; margin: 5px 0;`;
  const listItemStyle = 'line-height: 24px; font-size: 15px; color: #0C1B1E;';
  const listStyle = 'margin: 15px 0; font-family: Baskervville;';

  html = html.replaceAll('<p', `<p style="text-indent: 24px; ${normalTextStyles}"`);
  html = html.replaceAll('<blockquote>', '<blockquote><i>');
  html = html.replaceAll('</blockquote>', '</i></blockquote>');
  html = html.replaceAll('<blockquote', `<blockquote style="${blockquoteStyles}"`);
  html = html.replaceAll('" class="ql-align-center"', 'text-align: center;"');
  html = html.replaceAll('" class="ql-align-right"', 'text-align: right;"');
  html = html.replaceAll('<li', `<li style="${listItemStyle}"`);
  html = html.replaceAll('<ul', `<ul style="${listStyle}"`);
  html = html.replaceAll('<ol', `<ol style="${listStyle}"`);
  html = html.replaceAll('<h1', `<p style="${headerStyles1}"`);
  html = html.replaceAll('</h1>', '</p>');
  html = html.replaceAll('<h2', `<p style="${headerStyles2}"`);
  html = html.replaceAll('</h2>', '</p>');
  html = html.replaceAll('<h3', `<p style="${headerStyles3}"`);
  html = html.replaceAll('</h3>', '</p>');

  return html;
};

export default prepareHTMLDocxConversion;
